
import { defineComponent } from "vue";

export default defineComponent({
    name: "SLKSBlock",
    props: {
        bold: {
            type: Boolean,
            default: false,
        },
        action: {
            type: Boolean,
            default: true,
        },
    },
});
